<template>
    <RouterLink :to="to" class="flex gap-4 mx-auto justify-center items-center mt-16 md:flex-col md:text-2xl">
        <slot />
        <span class="material-symbols-outlined md:text-4xl">arrow_circle_right</span>
    </RouterLink>
</template>
<script>
export default {
    name: 'AtomButtonArrowRight',
    props: {
        to: {
            required: false,
            default() {
                return ''
            }
        },
    }
}
</script>
